import { Tenant } from '../types/types'
import Redirect from './Redirect'

const TENANT = process.env.REACT_APP_TENANT as Tenant
const isGlen = TENANT === 'GLENS_GR'

const Address = () => {
  if (!isGlen) return <Redirect url={'/'} placeholder={'homepage'} />
  
  return (
    <Redirect
      url={'https://maps.app.goo.gl/WwZiUqUwv3hLfTcT9'}
      placeholder={'homepage'}
    />
  )
}

export default Address
